<template>
    <div>
        <Head :title="__(title)" />
        <div class="bg-white rounded-md shadow overflow-hidden w-full">
            <form @submit.prevent="update">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Slug')" />
                </div>
                <div class="py-8 -mr-6 -mb-8 flex flex-wrap overflow-x-auto">
                    <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="overflow-hidden">
                            <table class="min-w-full">
                                <thead class="border-b">
                                    <tr>
                                        <th class="text-sm font-bold text-gray-900 px-6 py-4 text-left">Functions</th>
                                        <th v-for="perm in ['read', 'create', 'update', 'delete', 'export']" :key="perm"
                                            class="text-sm font-bold text-gray-900 px-6 py-4 text-left">
                                            {{ perm.charAt(0).toUpperCase() + perm.slice(1) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(value, name, index) in form.access" :key="index" class="border-b">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm capitalize text-gray-900">{{ name.replace('_', ' ') }}</td>
                                        <td v-for="perm in ['read', 'create', 'update', 'delete', 'export']" :key="perm"
                                            class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                            <label class="flex toggle_swtich items-center cursor-pointer">
                                                <div class="relative">
                                                    <input type="checkbox" class="sr-only" v-model="value[perm]" />
                                                    <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                                    <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                                                </div>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
                    <button v-if="!['admin','manager','customer'].includes(role.slug)" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete') }}</button>
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo() {
        return { title: this.form.name }
    },
    components: {
        LoadingButton,
        TextInput,
        Link,
        Head,
    },
    layout: Layout,
    props: {
        title: String,
        role: Object,
    },
    remember: 'form',
    data() {
        const allModules = [
            'ticket',
            'reports',
            'user',
            'knowledge_base',
            'faq',
            'blog',
            'chat',
            'smtp',
            'type',
            'global',
            'pusher',
            'status',
            'contact',
            'category',
            'customer',
            'language',
            'priority',
            'department',
            'organization',
            'email_template',
            'front_page'
        ]

        const defaultPermission = {
            read: false,
            create: false,
            update: false,
            delete: false,
            export: false,
        }

        let parsedAccess = {}
        try {
            parsedAccess = JSON.parse(this.role.access || '{}')
        } catch {
            parsedAccess = {}
        }

        // Tambahkan modul yang belum ada
        for (const moduleName of allModules) {
            parsedAccess[moduleName] = {
                ...defaultPermission,
                ...(parsedAccess[moduleName] || {})
            }
        }

        return {
            form: this.$inertia.form({
                name: this.role.name,
                slug: this.role.slug,
                access: parsedAccess,
            }),
        }
    },

    methods: {
        update() {
            this.form.put(this.route('roles.update', this.role.id))
        },
        destroy() {
            if (confirm('Are you sure you want to delete this role?')) {
                this.$inertia.delete(this.route('roles.destroy', this.role.id))
            }
        },
    },
}
</script>
